<template>
  <div>
    <v-container fluid>
      <NextWeekUpdateDialog v-if="approved_teacher === true"/>
      <v-snackbar
        :timeout="2000"
        v-model="openSnackbar"
        variant="tonal"
        class="ma-2"
        color="error"
        elevation="8"
      >
        <strong class="text-subtitle-1 pb-2">{{ errorMessage }}</strong>
      </v-snackbar>
      <v-card class="v-card--material pt-2 ma-1 rounded-lg" elevation="2">
        <v-row class="my-1">
          <v-col cols="12" lg="9" md="9" sm="9" xs="12">
            <div class="ml-2">
              <div
                class="font-weight-regular headline text-decoration-underline text-capitalize"
              >
                <span>Curriculum CMS</span>
              </div>
            </div>
          </v-col>
          <v-col cols="12" lg="3" md="3" sm="3" xs="12">
            <div class="d-flex grow flex-wrap justify-end">
              <router-link
                :to="{
                  name: 'curriculumCMSListView',
                  params: { current: 1 }
                }"
                target="_blank"
              >
                <v-btn
                  class="mr-2"
                  v-if="isWrite"
                  elevation="1"
                  color="success"
                  top
                >
                  <v-icon left>mdi-text-box-check</v-icon>
                  List View
                </v-btn>
              </router-link>
              <a @click="$router.back()">
                <v-btn
                  class="mr-3"
                  v-if="$vuetify.breakpoint.smAndUp"
                  elevation="1"
                  right
                  top
                >
                  <v-icon left>mdi-arrow-left</v-icon>back
                </v-btn>
                <v-btn
                  v-else
                  fixed
                  right
                  fab
                  small
                  color="grey lighten-2"
                  elevation="1"
                  class="mr-6"
                  top
                  style="opacity: 0.6; margin-top: 80px"
                >
                  <v-icon>mdi-arrow-left</v-icon>
                </v-btn>
              </a>
            </div>
          </v-col>
        </v-row>
        <card-component>
          <div>
            <v-row>
              <v-col cols="12" md="3">
                <label class="font-weight-medium body-2"
                  >Select academic year
                  <span class="error--text">*</span></label
                >
                <v-autocomplete
                  class="my-0 py-1"
                  v-model="academicYearID"
                  :items="academicYearData"
                  @change="resetAllData()"
                  key="id"
                  item-value="id"
                  item-text="academicYear"
                >
                </v-autocomplete>
              </v-col>
              <v-col cols="12" md="3">
                <label class="font-weight-medium body-2">
                  Select Business <span class="error--text">*</span></label
                >
                <v-autocomplete
                  class="my-0 py-1"
                  placeholder="--Select--"
                  name="businessSelect"
                  required
                  v-model="selectedBusinessID"
                  item-value="id"
                  @change="getBusinessWiseClassList()"
                  :items="business"
                  key="id"
                  item-text="name"
                >
                </v-autocomplete>
              </v-col>

              <v-col cols="12" md="3">
                <label class="font-weight-medium body-2">
                  Select Program<span class="error--text">*</span></label
                >
                <v-autocomplete
                  class="my-0 py-1"
                  placeholder="--Select--"
                  name="classSelect"
                  required
                  v-model="selectedProgramID"
                  item-value="id"
                  return-object
                  :items="programList"
                  key="classID"
                  item-text="name"
                >
                </v-autocomplete>
              </v-col>
              <v-col cols="12" md="3">
                <label class="font-weight-medium body-2"
                  >Select Week<span class="error--text">*</span></label
                >
                <v-autocomplete
                  class="my-0 py-1"
                  v-model="selectedWeekID"
                  :items="weekList"
                  key="id"
                  item-value="id"
                  item-text="weekName"
                >
                </v-autocomplete>
              </v-col>
              <v-col cols="12" md="4" v-if="isWrite">
                <label class="font-weight-medium body-2"> Select Zone</label>
                <v-autocomplete
                  key="id"
                  placeholder="Select Zone"
                  :items="zones"
                  v-model="selectedZones"
                  multiple
                  item-text="name"
                  :hide-details="true"
                  return-object
                  clearable
                  @change="getFranchiseeList()"
                >
                </v-autocomplete>
              </v-col>
              <v-col cols="12" md="6" v-if="selectedZones.length >= 1">
                <label class="font-weight-medium body-2">
                  Select Centers<span class="error--text">*</span></label
                >
                <v-autocomplete
                  :readonly="selectedZones.length >= 1"
                  key="id"
                  placeholder="--All Centers--"
                  :items="franchisees"
                  v-model="selectedFranchisees"
                  multiple
                  item-text="companyName"
                  item-value="id"
                  :hide-details="true"
                  return-object
                >
                </v-autocomplete>
              </v-col>
              <v-col cols="12" md="6" v-else>
                <label class="font-weight-medium body-2">
                  Select Centers<span class="error--text">*</span></label
                >
                <v-autocomplete
                  :readonly="selectedZones.length >= 1"
                  key="id"
                  placeholder="--All Centers--"
                  :items="franchisees"
                  v-model="selectedFranchisees"
                  multiple
                  item-value="id"
                  item-text="companyName"
                  :hide-details="true"
                  return-object
                  clearable
                >
                </v-autocomplete>
              </v-col>

              <v-col cols="12" md="2">
                <v-btn
                  @click="getCurriculumn"
                  color="primary"
                  right
                  title="Get Curriculum"
                  >Get Curriculum
                </v-btn>
              </v-col>
            </v-row>
          </div>
          <template>
            <v-card>
              <v-card-component>
                <v-row>
                  <v-col cols="12" md="6" sm="6" lg="6" xs="12">
                    <v-card-title>
                      <v-icon color="primary" elevation="1" left
                        >mdi-library-books</v-icon
                      >
                      <span v-if="themeName"
                        >{{ themeName }} (Class Time-
                        {{ totalClassTime }})</span
                      >
                    </v-card-title>
                  </v-col>
                  <v-col
                    v-if="!$vuetify.breakpoint.xs"
                    cols="12"
                    md="6"
                    sm="6"
                    lg="6"
                    xs="12"
                  >
                    <v-card-actions class="justify-end"  v-if="CurriculumAdmin || isSuperAdmin">
                      <v-btn
                        v-if="isWrite && isEnable"
                        :disabled="disableUploadButton"
                        title="Upload Resource"
                        @click="openBulkUpload()"
                        elevation="1"
                        color="accent"
                      >
                        <v-icon left>mdi-plus</v-icon>Upload Resources
                      </v-btn>
                      <v-btn
                        v-if="isWrite"
                        elevation="1"
                        color="success"
                        :disabled="disableUploadButton"
                        @click="isUploadWeekGlance = true"
                      >
                        <v-icon color="primary" elevation="1" left
                          >mdi-upload</v-icon
                        >
                        Upload Week Glance
                      </v-btn>
                    </v-card-actions>
                  </v-col>
                  <v-col v-else cols="12" xs="12">
                    <v-row no-gutters>
                      <v-col class="mb-2" cols="12" xs="12" v-if="CurriculumAdmin || isSuperAdmin">
                        <v-btn
                          v-if="isWrite"
                          :disabled="disableUploadButton"
                          title="Upload Resource"
                          @click="openBulkUpload()"
                          elevation="1"
                          color="accent"
                        >
                          <v-icon left>mdi-plus</v-icon>Upload Resources
                        </v-btn>
                      </v-col>
                      <v-col class="mb-2" cols="12" xs="12" v-if="CurriculumAdmin || isSuperAdmin">
                        <v-btn
                          v-if="isWrite"
                          elevation="1"
                          color="success"
                          :disabled="disableUploadButton"
                          @click="isUploadWeekGlance = true"
                        >
                          <v-icon color="primary" elevation="1" left
                            >mdi-upload</v-icon
                          >
                          Upload Week Glance
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <v-data-table
                  item-key="name"
                  :headers="headers"
                  :items="weekScheduleList"
                  disable-pagination
                  hide-default-footer
                >
                  <template v-slot:item.DAY_1="{ item }">
                    <router-link
                      target="_blank"
                      v-if="
                        item.DAY_1.title &&
                        item.DAY_1.title.toUpperCase() !== 'NA'
                      "
                      :to="{
                        name: 'dayGlanceResources',
                        params: { themeID: item.DAY_1.id }
                      }"
                    >
                      {{ item.DAY_1.title || '-' }}
                    </router-link>
                    <v-row v-else>-</v-row>
                  </template>
                  <template v-slot:item.DAY_2="{ item }">
                    <router-link
                      target="_blank"
                      v-if="
                        item.DAY_2.title &&
                        item.DAY_2.title.toUpperCase() !== 'NA'
                      "
                      :to="{
                        name: 'dayGlanceResources',
                        params: { themeID: item.DAY_2.id }
                      }"
                    >
                      {{ item.DAY_2.title || '-' }}
                    </router-link>
                    <v-row v-else>-</v-row>
                  </template>
                  <template v-slot:item.DAY_3="{ item }">
                    <router-link
                      target="_blank"
                      v-if="
                        item.DAY_3.title &&
                        item.DAY_3.title.toUpperCase() !== 'NA'
                      "
                      :to="{
                        name: 'dayGlanceResources',
                        params: { themeID: item.DAY_3.id }
                      }"
                    >
                      {{ item.DAY_3.title || '-' }}
                    </router-link>
                    <v-row v-else>-</v-row>
                  </template>
                  <template v-slot:item.DAY_4="{ item }">
                    <router-link
                      target="_blank"
                      v-if="
                        item.DAY_4.title &&
                        item.DAY_4.title.toUpperCase() !== 'NA'
                      "
                      :to="{
                        name: 'dayGlanceResources',
                        params: { themeID: item.DAY_4.id }
                      }"
                    >
                      {{ item.DAY_4.title || '-' }}
                    </router-link>
                    <v-row v-else>-</v-row>
                  </template>
                  <template v-slot:item.DAY_5="{ item }">
                    <router-link
                      target="_blank"
                      v-if="
                        item.DAY_5.title &&
                        item.DAY_5.title.toUpperCase() !== 'NA'
                      "
                      :to="{
                        name: 'dayGlanceResources',
                        params: { themeID: item.DAY_5.id }
                      }"
                    >
                      {{ item.DAY_5.title || '-' }}
                    </router-link>
                    <v-row v-else>-</v-row>
                  </template>
                  <template v-slot:item.DAY_6="{ item }">
                    <router-link
                      target="_blank"
                      v-if="
                        item.DAY_6 &&
                        item.DAY_6.title &&
                        item.DAY_6.title.toUpperCase() !== 'NA'
                      "
                      :to="{
                        name: 'dayGlanceResources',
                        params: { themeID: item.DAY_6.id }
                      }"
                    >
                      {{ item.DAY_6.title || '-' }}
                    </router-link>
                    <v-row v-else>-</v-row>
                  </template>
                  <template v-slot:item.action="{ item }">
                    <v-btn v-if="CurriculumAdmin || isSuperAdmin"
                      class="px-2 ml-1 ma-1"
                      @click="editCurriculumResources(item)"
                      depressed
                      small
                      color="primary"
                    >
                      Edit
                    </v-btn>
                  </template>
                </v-data-table>
              </v-card-component>
            </v-card>
          </template>
        </card-component>
      </v-card>

      <v-dialog
        v-model="isUploadWeekGlance"
        persistent
        width="80%"
        :active="isUploadWeekGlance"
        :on-cancel="
          () => {
            isUploadWeekGlance = false
          }
        "
      >
        <form action="modal-card-body" @submit.prevent="saveWeekTheme">
          <v-card>
            <v-toolbar dark color="darkblue">
              <v-toolbar-title>Upload Week Glance </v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <v-row>
                <v-col class="mt-2" cols="12" sm="5">
                  <label class="font-weight-medium body-2">
                    Week Theme:
                    <span class="requir error--text">*</span>
                  </label>
                  <v-text-field
                    required
                    v-model.trim="weekTheme"
                    placeholder="Enter Week Theme"
                  ></v-text-field>
                </v-col>
                <v-col class="mt-2" cols="12" sm="3">
                  <label class="font-weight-medium body-2">
                    Class Time (In Minutes):
                    <span class="requir error--text">*</span>
                  </label>
                  <v-text-field
                    type="Number"
                    min="1"
                    max="600"
                    required
                    v-model.trim="classTime"
                    placeholder="Class Time"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="4">
                  <label class="font-weight-medium body-2">
                    Download reference file: <br />
                  </label>
                  <v-btn
                    color="success"
                    href="https://intellitots.s3.ap-south-1.amazonaws.com/weekGlanceUpload.csv"
                  >
                    Download
                  </v-btn>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="5">
                  <b>File must contain: <br /></b>
                  <ul>
                    <li>Session (Name of the sesssion)</li>
                    <li>Time (Session time in minutes)</li>
                    <li>Day_1</li>
                    <li>Day_2</li>
                    <li>Day_3</li>
                    <li>Day_4</li>
                    <li>Day_5</li>
                    <li>Day_6</li>
                  </ul>
                </v-col>
                <v-col cols="12" sm="6">
                  <label class="font-weight-medium body-2">
                    Upload file:
                    <span class="requir has-text-danger"
                      >* (Accepts: .csv)</span
                    >
                    <span class="requir error--text">*</span>
                  </label>
                  <v-file-input
                    @change="csvToJsonInput(weekGlanceFile)"
                    v-model="weekGlanceFile"
                    placeholder="Click here to Upload File"
                    :messages="['(max file size allowed 5MB)']"
                    accept=".csv"
                  ></v-file-input>
                </v-col>
              </v-row>
            </v-card-text>
            <v-row>
              <v-col cols="12" sm="12">
                <v-data-table
                  v-if="jsonData.length"
                  item-key="name"
                  :headers="JSONDataHeaders"
                  :items="jsonData"
                  disable-pagination
                  hide-default-footer
                >
                </v-data-table>
              </v-col>
            </v-row>
            <v-card-actions class="d-flex justify-end">
              <v-btn align="right" color="error" @click="resetData"
                >Cancel</v-btn
              >
              <v-btn align="right" color="primary" type="submit"
                >Upload File</v-btn
              >
            </v-card-actions>
          </v-card>
        </form>
      </v-dialog>
    </v-container>
    <loading-icon :value="isLoading" />
  </div>
</template>
<script>
import CardComponent from '@/components/template/CardComponent'
import VCardComponent from '@/components/template/VCardComponent'
import constants from '@/utils/constants'
import Utils from '@/utils'
import _ from 'lodash'
import NextWeekUpdateDialog from '@/components/Acad/Learning/nextWeekUpdateDialog.vue'
import { mapGetters } from 'vuex'
import csvtojsonV2 from 'csvtojson'
import stores from '@/stores'
export default {
  name: 'curriculumCMS',
  components: {
    CardComponent,
    VCardComponent,
    NextWeekUpdateDialog
  },
  props: {
    curriculumCmsId: {
      type: String,
      default: ''
    },
    weekId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      valid: true,
      dialog: false,
      academicYearData: [],
      franchisees: [],
      selectedFranchisees: [],
      selectedClassID: null,
      isLoading: true,
      franchiseeID: '',
      selectedProgramID: '',
      selectedWeekID: '',
      programList: [],
      weekList: [],
      academicYearID: '',
      errorMessage: null,
      openSnackbar: false,
      business: [],
      selectedBusinessID: {},
      isWrite: false,
      isActive: true,
      businessProgramMapID: null,
      curriculumnWeekID: null,
      jsonData: [],
      week: 'WEEK',
      allowedFiles: ['pdf', 'jpg', 'png', 'jpeg'],
      weekScheduleList: [],
      theme: '',
      isUploadWeekGlance: false,
      classTime: null,
      totalClassTime: null,
      weekGlanceFile: null,
      dayArray: {},
      disableUploadButton: true,
      weekTheme: null,
      themeName: null,
      newData: [],

      item: [],
      JSONDataHeaders: [
        {
          text: 'Session',
          value: 'Session',
          sortable: false
        },
        {
          text: 'Time',
          value: 'Time',
          sortable: false
        },
        {
          text: 'Day_1',
          value: 'Day_1',
          sortable: false
        },
        {
          text: 'Day_2',
          value: 'Day_2',
          sortable: false
        },
        {
          text: 'Day_3',
          value: 'Day_3',
          sortable: false
        },
        {
          text: 'Day_4',
          value: 'Day_4',
          sortable: false
        },
        {
          text: 'Day_5',
          value: 'Day_5',
          sortable: false
        },
        {
          text: 'Day_6',
          value: 'Day_6',
          sortable: false
        }
      ],
      headers: [
        {
          text: 'Session',
          name: 'Session',
          value: 'Session',
          align: 'center',
          maxWidth: '10%',
          sortable: false
        },
        {
          text: 'Time (In Minutes)',
          name: 'Time',
          value: 'Time',
          align: 'center',
          maxWidth: '10%',
          sortable: false
        },
        {
          text: 'DAY 1',
          name: 'DAY_1',
          value: 'DAY_1',
          align: 'center',
          maxWidth: '20%',
          sortable: false
        },
        {
          text: 'DAY 2',
          name: 'DAY_2',
          value: 'DAY_2',
          align: 'center',
          sortable: false
        },
        {
          text: 'DAY 3',
          name: 'DAY_3',
          value: 'DAY_3',
          align: 'center',
          sortable: false
        },
        {
          text: 'DAY 4',
          name: 'DAY_4',
          value: 'DAY_4',
          align: 'center',
          sortable: false
        },
        {
          text: 'DAY 5',
          name: 'DAY_5',
          value: 'DAY_5',
          align: 'center',
          sortable: false
        },
        {
          text: 'DAY 6',
          name: 'DAY_6',
          value: 'DAY_6',
          align: 'center',
          sortable: false
        }
      ],
      zones: [],
      selectedZones: [],
      weekGlanceDetails: {
        Session: '',
        Time: '',
        DAY_1: '',
        DAY_2: '',
        DAY_3: '',
        DAY_4: '',
        DAY_5: '',
        DAY_6: ''
      },
      isEditWeekGlance: false,
      isEnable: false,
      viewItem: {},
      // isSuperAdmin: false,
      approved_teacher: false,
      CurriculumAdmin: false
    }
  },
  async created () {
    await this.getAcademicYearsList()
    await this.getFranchiseeList()
    await this.getWeekList()
    await this.getBusinessList()
    this.create = this.checkModuleAccess('create')
    this.isWrite = Utils.helper.getIsWriteFun(this.$route)
    await this.getZoneDetails()
    if (stores.user.me.superAdmin === false) {
      for (const item of stores.user.roles) {
        if (item.role === 'APPROVED_TEACHER') {
          this.approved_teacher = true
        } else if (item.role === 'CurriculumAdmin') {
          this.CurriculumAdmin = true
        }
      }
    }
    if (this.isWrite) {
      if (this.CurriculumAdmin || stores.user.me.superAdmin) {
        this.headers.push({
          text: 'Action',
          name: 'action',
          value: 'action',
          align: 'center',
          sortable: false
        })
      }
    }
    if ((this.curriculumCmsId) || (this.curriculumCmsId && this.weekId)) {
      await this.getCurriculumFilterData()
    }
    if (this.viewItem.length > 0) {
      this.setCurriculumCMSFilterData()
    }
  },
  watch: {
    franchisee: async function (val) {
      await this.onFranchiseeChange()
    },
    academicYear: async function (val) {
      await this.onFranchiseeChange()
    }
  },
  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee',
      academicYear: 'getAcademicYear'
    }),
    isSuperAdmin: function () {
      return stores.user.me.superAdmin
    }
  },
  methods: {
    getCookie (cookieName) {
      let name = cookieName + '='
      let decodedCookie = decodeURIComponent(document.cookie)
      let cookieArray = decodedCookie.split(';')
      for (let i = 0; i < cookieArray.length; i++) {
        let cookie = cookieArray[i]
        while (cookie.charAt(0) === ' ') {
          cookie = cookie.substring(1)
        }
        if (cookie.indexOf(name) === 0) {
          return cookie.substring(name.length, cookie.length)
        }
      }
      return null
    },
    getCurriculumFilterData: async function () {
      try {
        this.isLoading = true
        const { data } = await http.get(
          `${constants.API_URL}/api/curriculum_cms/get-curriculum-week/${this.curriculumCmsId}/${this.weekId}`
        )
        this.viewItem = data
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    setCurriculumCMSFilterData: async function () {
      let item = this.viewItem
      this.academicYearID = ''
      this.selectedBusinessID = {}
      this.selectedProgramID = ''
      this.selectedWeekID = ''
      this.selectedZones = []
      this.selectedFranchisees = []
      if (!_.isEmpty(item) && item.length > 0) {
        item.curriculumCMSAcademicYearMaps.forEach((item) => {
          this.academicYearID = item.franchiseeAcademicYear.id
        })
        if (item.curriculumBusinessProgramMap.businessID) {
          this.selectedBusinessID = item.curriculumBusinessProgramMap.businessID
          if (this.selectedBusinessID) {
            await this.getBusinessWiseClassList()
          }
        }
        this.selectedProgramID = {
          businessProgramMapID: item.businessProgramMapID,
          classID: item.curriculumCMSClassMaps[0].studentClass.id,
          name: item.curriculumCMSClassMaps[0].studentClass.name
        }
        item.curriculumCMSWeekMaps.forEach((weekItem) => {
          if (weekItem.week.id === parseInt(this.weekId)) {
            this.selectedWeekID = weekItem.week.id
          }
        })
        item.curriculumCMSZoneMaps.forEach((item) => {
          this.selectedZones.push(item.zone)
        })
        if (this.selectedZones.length > 0) {
          this.getFranchiseeList()
        } else {
          item.curriculumCMSCenterMaps.forEach((item) => {
            if (item.franchisee) {
              this.selectedFranchisees.push(item.franchisee)
            }
          })
        }
        this.getCurriculumn()
      }
    },
    onFranchiseeChange: async function () {
      if (!this.inProgress) {
        this.inProgress = true
        if (this.franchisee) {
          this.franchiseeID = this.franchisee.id
        } else {
          this.franchiseeID = ''
        }
        if (this.academicYear) {
          this.academicYearID = this.academicYear.id
        } else {
          this.academicYearID = ''
        }
        if (this.franchiseeID && this.academicYearID) {
          // await this.getFranchiseeList()
        }
        this.inProgress = false
      }
    },
    getFranchiseeList: async function () {
      try {
        this.isLoading = true
        let zone = this.selectedZones.map((zone) => {
          return zone.name
        })
        const response = await http.post(
          `${constants.API_URL}/api/franchisee/get/zone-wise-franchisee`,
          {
            zone: zone
          }
        )
        let data = response.data
        this.franchisees = _.map(data, (e) => {
          if (e.id) {
            if (e.id.toString().length === 1) {
              e.companyName = `${'(00' + e.id + ')'} ` + e.companyName
            } else if (e.id.toString().length === 2) {
              e.companyName = `${'(0' + e.id + ')'} ` + e.companyName
            } else {
              e.companyName = `${'(' + e.id + ')'} ` + e.companyName
            }
            e.companyName = e.region
              ? e.companyName + `${' (' + e.region + ')'}`
              : e.companyName
          }
          return e
        })
        if (this.franchisees.length >= 1) {
          this.selectedFranchisees = this.franchisees
        }
        if (this.selectedZones.length === this.zones.length) {
          this.selectedFranchisees = []
        }
        if (this.selectedZones.length === 0) {
          this.selectedFranchisees = []
        }
        // console.log('this.selectedFranchisees ', this.selectedFranchisees)
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    getBusinessList: async function () {
      try {
        this.isLoading = true
        const { data } = await http.get(
          `${constants.API_URL}/api/curriculum_cms/get-business`
        )
        if (data) {
          this.business = data
        }
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
        console.log('errorMessage', errorMessage)
      }
    },
    getWeekList: async function () {
      try {
        this.isLoading = true
        const { data } = await http.get(
          `${constants.API_URL}/api/curriculum_cms/week/get/all`
        )
        if (data) {
          this.weekList = data
        }
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
        console.log('errorMessage', errorMessage)
      }
    },
    getBusinessWiseClassList: async function () {
      try {
        this.isLoading = true
        if (!this.academicYearID) {
          return
        }
        const { data } = await http.get(
          `${constants.API_URL}/api/curriculum_cms/get-program?id=${this.selectedBusinessID}&&academicYearID=${this.academicYearID}`
        )
        if (data) {
          this.programList = data.map((obj) => {
            return {
              businessProgramMapID: obj.id,
              classID: obj.classID,
              name: obj.studentClass.name
            }
          })
        }
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
        console.log('errorMessage', errorMessage)
      }
    },
    getAcademicYearsList: async function () {
      this.isLoading = true
      let rows = await http.get(
        `${constants.API_URL}/api/franchiseeAcademicYears`
      )
      this.academicYearData = rows.data.rows
      const currentAcademicYear = Utils.getCurrentAcademicYear()
      let academicYear = this.academicYearData.find((y) => {
        return y.academicYear.trim() === currentAcademicYear.trim()
      })
      this.academicYearID = academicYear ? academicYear.id : ''
      this.isLoading = false
    },
    checkModuleAccess: function (moduleName) {
      return Utils.helper.checkAccessByModule(this.$route, moduleName)
    },
    getCurriculumn: async function () {
      try {
        this.disableUploadButton = true
        this.isLoading = true
        if (!this.academicYearID) {
          this.openSnackbar = true
          this.errorMessage = 'Please select Academic Year!'
        }
        if (!this.selectedBusinessID) {
          this.openSnackbar = true
          this.errorMessage = 'Please select business!'
          return
        }
        if (!this.selectedProgramID) {
          this.openSnackbar = true
          this.errorMessage = 'Please select Program!'
          return
        }
        if (!this.selectedWeekID) {
          this.openSnackbar = true
          this.errorMessage = 'Please select week!'
          return
        }
        this.disableUploadButton = false
        this.businessProgramMapID = this.selectedProgramID.businessProgramMapID
        this.isLoading = true
        let allCenterAccess = false
        let franchiseeArray = null
        let zoneArray = null
        if (
          !this.selectedFranchisees.length ||
          this.selectedZones.length === this.zones.length
        ) {
          if (this.zones.length === 1 && this.isWrite) {
            zoneArray = this.selectedZones.map((zone) => {
              return zone.id
            })
          } else {
            allCenterAccess = true
          }
        } else if (
          this.selectedZones.length > 0 &&
          this.selectedZones.length < this.zones.length
        ) {
          zoneArray = this.selectedZones.map((zone) => {
            return zone.id
          })
        } else {
          franchiseeArray = this.selectedFranchisees.map((obj) => obj.id)
        }
        let query = {
          businessProgramMapID: this.businessProgramMapID,
          classID: this.selectedProgramID.classID,
          academicYearID: this.academicYearID,
          franchiseeID: franchiseeArray || null,
          allCenterAccess: allCenterAccess,
          weekID: this.selectedWeekID,
          zones: zoneArray
        }
        const { data } = await http.post(
          `${constants.API_URL}/api/curriculum_cms/get/all`,
          query
        )
        this.curriculumnWeekID = null
        if (data.success === 99) {
          this.isEnable = false
          return this.resetWeekSchedule()
        }
        if (data.data) {
          if (data.data.curriculumCMSWeekMaps.length) {
            this.curriculumnWeekID = data.data.curriculumCMSWeekMaps[0].id
          }
        }
        if (this.curriculumnWeekID) {
          await this.getWeekScheduleList()
        }

        if (data.success === 201) {
          return this.errMsg(data.message)
        }
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        await this.resetWeekSchedule()
        return this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    csvToJsonInput: async function (files) {
      const loadingComponent = this.$buefy.loading.open()
      try {
        if (files.length > 1) {
          this.dropFiles.splice(0, 1)
        }
        let file = files
        this.readerFile(file, async (e) => {
          try {
            this.jsonData = await csvtojsonV2().fromString(e.target.result)
            if (!this.jsonData[0].Session || !this.jsonData[0].Time) {
              this.jsonData = []
              this.weekGlanceFile = null
              return this.errMsg('Inavlid File Data')
            }
          } catch (e) {
            this.jsonData = ''
            const errorMessage =
              (e && e.response && e.response.data.message) || e.message
            return this.errMsg(errorMessage)
          }
        })
        this.flag = true
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        console.log('e :', errorMessage)
      } finally {
        loadingComponent.close()
      }
    },
    readerFile: function (file, onLoadCallback) {
      let reader = new FileReader()
      reader.onload = onLoadCallback
      reader.readAsText(file)
    },
    deleteDropFile (i) {
      this.dropFile.splice(i, 1)
    },
    saveWeekTheme: async function () {
      const loadingComponent = this.$buefy.loading.open()
      try {
        if (!this.weekTheme) {
          return this.errMsg('Week Theme is required!')
        }
        if (!this.classTime) {
          return this.errMsg('Class time is required!')
        }
        if (!this.jsonData.length) {
          return this.errMsg('Please upload file')
        }
        for (let obj of this.jsonData) {
          if (!Number(obj.Time)) {
            throw new Error('Session Time must be number!')
          }
          if (obj.Session === '' || obj.Session == null) {
            throw new Error('Session name is required for all rows!')
          }
        }
        if (!this.curriculumnWeekID) {
          let allCenterAccess = false
          let franchiseeArray = []
          let zoneArray = []
          console.log(this.selectedZones.length)
          console.log(this.selectedZones.length > 0)
          console.log()
          if (
            !this.selectedFranchisees.length ||
            this.selectedZones.length === this.zones.length
          ) {
            console.log('in if ')
            if (this.zones.length === 1) {
              console.log('in if length 1')
              zoneArray = this.selectedZones.map((obj) => obj.id)
            } else {
              console.log('in else')
              allCenterAccess = true
            }
          } else if (
            this.selectedZones.length > 0 &&
            this.selectedZones.length < this.zones.length
          ) {
            console.log('in else if')
            zoneArray = this.selectedZones.map((obj) => obj.id)
          } else {
            console.log('in else ')
            franchiseeArray = this.selectedFranchisees.map((obj) => obj.id)
          }
          let payload = {
            businessProgramMapID: this.businessProgramMapID,
            classID: this.selectedProgramID.classID,
            academicYearID: this.academicYearID,
            franchiseeID: franchiseeArray || null,
            allCenterAccess: allCenterAccess,
            weekID: this.selectedWeekID,
            zoneID: zoneArray
          }
          const { data } = await http.post(
            `${constants.API_URL}/api/curriculum_cms/create`,
            payload
          )
          if (data.data) {
            if (data.data.curriculumCMSWeekMaps.length) {
              this.curriculumnWeekID = data.data.curriculumCMSWeekMaps[0].id
            }
          }
        }
        const payload = {
          weekID: this.curriculumnWeekID,
          themeName: this.weekTheme,
          classTime: this.classTime,
          scheduleData: this.jsonData
        }
        await http.post(
          `${constants.API_URL}/api/curriculum_cms/weekschedule/bulk-upload`,
          payload
        )
        await this.resetData()
        await this.getWeekScheduleList()
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        loadingComponent.close()
      }
    },
    getWeekScheduleList: async function () {
      try {
        this.isLoading = true
        let res = await http.get(
          `${constants.API_URL}/api/curriculum_cms/get-week/${this.curriculumnWeekID}`
        )
        if (res.data.success !== 200 || !res.data.weekAtGlance.length) {
          this.isEnable = false
          return this.resetWeekSchedule()
        }
        this.isEnable = true
        this.themeName = ''
        let days = res.data.weekAtGlance

        this.themeName = days[0].themeName || null
        this.totalClassTime = days[0].classTime || null
        if (this.totalClassTime) {
          const minutes = Number(this.totalClassTime % 60)
          const hours = Number(this.totalClassTime / 60).toFixed(0)
          this.totalClassTime = `${hours} hours`
          if (minutes > 0) {
            this.totalClassTime = `${hours} hours ${minutes} min `
          }
        }
        days = days.sort(function (a, b) {
          return a.dayName.localeCompare(b.dayName)
        })
        let row = {}
        row['Time'] = []
        row['Session'] = []
        let daysArray = []

        for (let day of res.data.weekAtGlance) {
          day.weekDay = _.orderBy(day.weekDay, 'position', 'asc')
          daysArray.push(day.dayName)
          row[day.dayName] = day.weekDay
        }
        let finalData = []
        let TimeArray = row[daysArray[0]].map((obj) => obj.themeTime)
        let sessionArray = row[daysArray[0]].map((obj) => obj.theme)
        for (let i in TimeArray) {
          let obj = {}
          obj.Time = TimeArray[i]
          obj.Session = sessionArray[i]
          for (let day of daysArray) {
            let dayName = day.split(' ').join('_').toUpperCase()
            obj[dayName] = row[day][i]
          }
          finalData.push(Object.assign({}, obj))
        }
        this.weekScheduleList = finalData
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    resetData: async function () {
      this.weekTheme = null
      this.isUploadWeekGlance = false
      this.classTime = null
      this.weekGlanceFile = null
      this.jsonData = []
    },
    resetAllData: async function () {
      this.themeName = null
      this.totalClassTime = null
      this.selectedFranchisees = []
      this.selectedProgramID = null
      this.selectedWeekID = null
      this.weekTheme = null
      this.weekScheduleList = []
      this.isUploadWeekGlance = false
      this.classTime = null
      this.weekGlanceFile = null
      this.jsonData = []
      this.selectedZones = []
    },
    resetWeekSchedule: function () {
      this.weekScheduleList = []
      this.themeName = null
      this.totalClassTime = null
    },
    modalOpen (type) {
      this.lessonDialog = false
      this.resourceDialog = false
      this.isUploadLesson = false
      this.isUploadResources = false

      if (type === this.lessonType) {
        this.isUploadLesson = true
        this.lessonDialog = true
      } else {
        this.isUploadResources = true
        this.resourceDialog = true
      }
    },
    okMsg (msg) {
      return this.$dialog.info({
        text: msg,
        title: 'Success'
      })
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    },
    getZoneDetails: async function () {
      try {
        this.isLoading = true
        let result = await http.get(
          `${constants.API_URL}/api/curriculum_cms/get-zones`
        )

        this.zones = result.data
        // console.log('Zones 992 ', this.zones)
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    editCurriculumResources: async function (item) {
      console.log('in edit ', item)
      console.log(this.programList, this.selectedProgramID)
      let route = this.$router.resolve({
        name: 'editDayGlanceDetails',
        params: {
          folderMapID: this.curriculumnWeekID,
          position: item.DAY_1.position
        }
      })
      window.open(route.href, '_blank')
    },
    openBulkUpload: async function () {
      let route = this.$router.resolve({
        name: 'bulkUploadCurriculumCMS',
        params: { folderMapID: this.curriculumnWeekID }
      })
      window.open(route.href, '_blank')
    },
    resetUpdateData: async function () {
      this.isEditWeekGlance = false
      this.weekGlanceDetails.Session = ''
      this.weekGlanceDetails.Time = ''
      this.weekGlanceDetails.DAY_1 = ''
      this.weekGlanceDetails.DAY_2 = ''
      this.weekGlanceDetails.DAY_3 = ''
      this.weekGlanceDetails.DAY_4 = ''
      this.weekGlanceDetails.DAY_5 = ''
      this.weekGlanceDetails.DAY_6 = ''
    }
  }
}
</script>
<style scoped>
.tile.is-child {
  border: 1px solid #ff000059;
}
.fol-name {
  overflow-wrap: break-word;
}
.foldr {
  cursor: pointer;
}
.islink {
  cursor: pointer;
}
.isBlueLink {
  color: #0d6efd;
  text-decoration: underline;
}
.shortFoldername {
  width: 155px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.shortFoldername:hover {
  overflow: visible;
  white-space: normal;
  width: auto;
  position: absolute;
  background-color: #fff;
}
</style>
